import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { DialogTitle, DialogContent, DialogActions, Grid } from "@mui/material";
import { StyledDialog } from "../../../../common/components/Dialog";
import { StyledButton } from "../../../../common/components/Button";
import { StyledTextField } from "../../../../common/components/TextField/styles";
import { yupResolver } from "@hookform/resolvers/yup";
import { addTreatmentTypeSchema } from "../../schemas/treatmentTypesSchema";
import { addTreatmentType } from "../../../../api/treatmentTypesApi";
const AddTreatmentTypeDialog = ({
  openAddTreatmentType,
  handleCloseAddTreatmentType,
  fetchTreatmentTypes,
}) => {
  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
  } = useForm({
    resolver: yupResolver(addTreatmentTypeSchema),
  });

  const submitAddTreatmentType = async (values) => {
    await addTreatmentType(values);
    handleCloseAddTreatmentType();
    fetchTreatmentTypes();
  };

  return (
    <div>
      <StyledDialog
        open={openAddTreatmentType}
        onClose={handleCloseAddTreatmentType}
        fullWidth
        maxWidth="md"
      >
        <DialogTitle> Add Treatment Type</DialogTitle>
        <form onSubmit={handleSubmit(submitAddTreatmentType)}>
          <DialogContent dividers>
            <Grid container direction="row">
              <Grid item xs={10}>
                <StyledTextField
                  label="Name"
                  id="name"
                  variant="outlined"
                  error={Boolean(errors.name)}
                  helperText={errors.name?.message}
                  {...register("name")}
                  sx={{ width: "100%" }}
                />
              </Grid>
              <Grid item xs={10}>
                <StyledTextField
                  name="totalPayment"
                  margin="dense"
                  variant="outlined"
                  label="Total Payment"
                  type="number"
                  id="package-name"
                  InputProps={{ inputProps: { step: "any" } }}
                  error={errors.totalPayment}
                  helperText={errors.totalPayment?.message}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  {...register("totalPayment")}
                  sx={{ width: "100%" }}
                />
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <StyledButton
              theme="purple"
              type="button"
              onClick={handleCloseAddTreatmentType}
            >
              Cancel
            </StyledButton>
            <StyledButton theme="green" type="submit" disabled={isSubmitting}>
              Submit
            </StyledButton>
          </DialogActions>
        </form>
      </StyledDialog>
    </div>
  );
};

export default AddTreatmentTypeDialog;
